import React, { useEffect, useRef } from 'react'
import './whitepapertopics.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Whitepapertopics = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);
  
    useEffect(() => {
      const cards = cardRefs.current;
  
      const initialPositions = [
        { x: 0, y: 100, opacity: 0 },
        { x: 0, y: 150, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
        { x: 0, y: 250, opacity: 0 },
        { x: 0, y: 300, opacity: 0 },
        { x: 0, y: 350, opacity: 0 },
        { x: 0, y: 350, opacity: 0 }
      ];
  
      cards.forEach((card, index) => {
        gsap.fromTo(
          card,
          initialPositions[index], 
          {
            x: 0,
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 120%",
              toggleActions: "play none none none",
            //   markers: true
            },
          }
        );
  
        gsap.set(card, { transformOrigin: "center" });
  
        card.addEventListener("mouseenter", () => {
          gsap.to(card, { scale: 1.05, duration: 0.3 });
        });
  
        card.addEventListener("mouseleave", () => {
          gsap.to(card, { scale: 1, duration: 0.3 });
        });
      });
    }, []);
    return (
        <>
            <section className='topicwhitepaperprnt'>
                <div className="postionimgtopic">
                    <img className='img-fluid' src="\assets\Whitepaper\topicswhitepaperpostion.png" alt="" />
                </div>
                <div className="custom-container" ref={sectionRef}>
                    <div className="topicswhitepaperchldmain">
                        <h1>Key Topics Covered</h1>
                        <div className="cardtopicsmain">
                            <dic className="card1topicwhitepaper" ref={(el) => (cardRefs.current[0] = el)}>
                                <h6>01.</h6>
                                <h2>Introduction to TOMI</h2>
                                <p>Our mission to decentralize the internet and empower users.</p>
                            </dic>
                            <dic className="card1topicwhitepaper" ref={(el) => (cardRefs.current[1] = el)}>
                                <h6>02.</h6>
                                <h2>The Problem We’re Solving</h2>
                                <p>Built on a blockchain-powered infrastructure, eliminating single points of failure.</p>
                            </dic>
                            <dic className="card1topicwhitepaper" ref={(el) => (cardRefs.current[2] = el)}>
                                <h6>03.</h6>
                                <h2>Our Solution</h2>
                                <p>How TOMI’s SuperApp integrates Web3 technologies for secure communication, payments, and browsing.</p>
                            </dic>
                            <dic className="card1topicwhitepaper" ref={(el) => (cardRefs.current[3] = el)}>
                                <h6>04.</h6>
                                <h2>Technical Details</h2>
                                <p>Core infrastructure and decentralized technologies powering the tomi ecosystem.</p>
                            </dic>
                            <dic className="card1topicwhitepaper" ref={(el) => (cardRefs.current[4] = el)}>
                                <h6>05.</h6>
                                <h2>Roadmap Highlights</h2>
                                <p>A phased rollout plan introducing key features from 2025 to 2026.</p>
                            </dic>
                            <dic className="card1topicwhitepaper" ref={(el) => (cardRefs.current[5] = el)}>
                                <h6>06.</h6>
                                <h2>Vision for the Future</h2>
                                <p>Long-term goals for tomi’s impact on global connectivity and digital freedom.</p>
                            </dic>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Whitepapertopics